<template>
    <div class="daq-header" :class="{active: active || always}">
        <router-link class="daq-header-logo" to="/index">
            <span class="img"></span>
        </router-link>
    </div>
</template>
<script>
    export default {
        data () {
            return {
                always: false,
                active: false,
                tabIndex: 0,
            }
        },
        mounted () {
            window.addEventListener('scroll', this.scrollHandler)
        },
        methods: {
            // 滚动相关事件
            scrollHandler () {
                if (window.pageYOffset > 0) {
                    this.active = true
                } else {
                    this.active = false
                }
            }
        },
        watch: {
            $route (to) {
                if (to.path === '/document-desc' || to.path === '/apply-join/fw' || to.path === '/apply-join' || to.path === '/apply-join/fx' || to.path === '/apply-join/kfz' || to.path === '/news-desc') {
                    this.always = true
                } else {
                    this.always = false
                }
                let path = to.matched[0].path
                if (path.indexOf('elec') !== -1 || path.indexOf('wisdom') !== -1 || path.indexOf('haojing') !== -1 || path.indexOf('huizheng') !== -1 || path.indexOf('tourism-cloud') !== -1) {
                    this.tabIndex = 1
                } else if (path.indexOf('solution') !== -1) {
                    this.tabIndex = 2
                } else if (path.indexOf('document') !== -1) {
                    this.tabIndex = 3
                } else if (path.indexOf('cooperation-index') !== -1 || path.indexOf('apply-join') !== -1) {
                    this.tabIndex = 4
                } else {
                    this.tabIndex = 0
                }
            }
        },
        beforeDestroy () {
            window.removeEventListener('scroll', this.scrollHandler)
        }
    }
</script>
<style lang="scss" scoped>
    .daq-header {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 99;
        display: flex;
        justify-content: space-between;
        width: 100%;
        height: 60px;
        color: $fc10;
        transition: all .3s linear;
        border-bottom: 1px solid rgba(255, 255, 255, .2);
        &:hover,
        &.active
        {
            background: #020914;
            &::after {
                background: none;
            }
        }
        &-logo {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0 32px;
            height: 100%;
            font-size: $f18;
            background: $bg01;
            .img {
                display: block;
                width: 195px;
                height: 36px;
                background: url('../assets/images/header-logo.png') no-repeat center;
            }
        }
    }
</style>
